export default "__VITE_ASSET__16dc0763__"